import Button from "react-bootstrap/Button"
import Dropdown from "react-bootstrap/Dropdown"
import Modal from "react-bootstrap/Modal"
import { useEffect, useState } from "react"

import "./global-prune-old-versions.css"
import { post } from "../../internal/request"
import { API_ADDR } from "../../App"

interface Props {
  show: boolean
  runtimeEnv: string
  onHide: (() => void)
}

export default function GlobalPruneOldVersions(props: Props) {

  const [versionsToKeep, setVersionsToKeep] = useState(2);  // Default to keeping 2 versions (where possible)
  const [environment, setEnvironment] = useState(props.runtimeEnv)
  const [progress, setProgress] = useState(0);  // 0=ready, 1=trigger me, 2=in progress, 3=done
  const [errMessage, setErrMessage] = useState("")

  useEffect(() => {
    if (props.show) {
      setProgress(0)
      setEnvironment(props.runtimeEnv)
    }
  }, [props.show, props.runtimeEnv])

  function prune() {

    if (progress === 3) {
      props.onHide()
      return
    }

    // Trigger a prune
    setProgress(2)

    post(`${API_ADDR()}/api/prune?environment=${environment}&versionstokeep=${versionsToKeep}`)
      .then(() => {
        // Call done func
        setProgress(3)
      })
      .catch((err) => {
        // Call done func with error
        setProgress(3)
        setErrMessage(err)
      })
  }

  const ddOptions = []

  // Since the min/max prunable cannot be known for multiple hotel ref IDs, just use
  // a boilerplate range of 1-10. The prune function will always leave the number you
  // select; if there are fewer versions available, it won't prune that hotel.
  for (var i = 1; i <= 10; i++) {
    ddOptions.push(<Dropdown.Item key={i} eventKey={i}>{i}</Dropdown.Item>)
  }

  return <Modal
    show={props.show}
    size="lg"
    centered
    backdrop="static"
    keyboard={false}
  >
    <Modal.Header>
      <Modal.Title>
        <div>Prune old versions</div>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>Prune old versions from the
        <Dropdown as="span" style={{ marginLeft: 5, marginRight: 5 }} onSelect={(eventkey) => setEnvironment(eventkey ?? "")}>
          <Dropdown.Toggle variant="secondary" id="choose-environment" disabled={progress > 0}>{environment}</Dropdown.Toggle>
          <Dropdown.Menu>
            {props.runtimeEnv === "localhost"
              ? <Dropdown.Item key="localhost" eventKey="localhost">localhost</Dropdown.Item>
              : null
            }
            <Dropdown.Item key="dev" eventKey="dev">dev</Dropdown.Item>
            <Dropdown.Item key="staging" eventKey="staging">staging</Dropdown.Item>
            <Dropdown.Item key="live" className="extra-warn" eventKey="live">live</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        environment cache, retaining at least
        <Dropdown as="span" style={{ marginLeft: 5, marginRight: 5 }} onSelect={(eventkey) => setVersionsToKeep(+(eventkey ?? "2"))}>
          <Dropdown.Toggle variant="secondary" id="choose-versions-to-keep">{versionsToKeep}</Dropdown.Toggle>
          <Dropdown.Menu>
            {ddOptions}
          </Dropdown.Menu>
        </Dropdown>
        {versionsToKeep === 1 ? "version" : "versions"}.</div>
      {errMessage !== "" ? <div className="extra-warn">{errMessage}</div> : null}
    </Modal.Body>
    <Modal.Footer>
      {progress !== 3 ? <Button variant="secondary" disabled={progress >= 2} onClick={props.onHide}>Cancel</Button> : null}
      <Button onClick={() => prune()} disabled={progress === 2} >{progress < 2 ? "Prune" : progress > 2 ? "Done" : "Pruning..."}</Button>
    </Modal.Footer>
  </Modal>
}